import React from 'react'
import './style.min.css'

const HeroDescription = ({
  smallText, mediumText, mainTextLarge, mainTextMedium, description
}) => (
  <div className="DescriptionContainer padding-32 padding-small" style={{ zIndex: '1' }}>
    {smallText && <p className="Description">{smallText}</p>}
    {mediumText && <h2 className="MediumText padding-16">{mediumText}</h2>}
    {mainTextLarge && <h2 className="MainTextLarge padding-32">{mainTextLarge}</h2>}
    {mainTextMedium && <h2 className="MainTextMedium padding-32">{mainTextMedium}</h2>}
    {description && <p className="Description padding-16">{description}</p>}
  </div>
)

export default HeroDescription